import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { runModelCurrencyCheck } from "@/services/adminModelCurrency";
import { describeApiError } from "./helpers";
import { describeCheckResult } from "./providerHelpers";

const CheckNowButton = ({ onDone }: { onDone: () => void | Promise<void> }) => {
  const { toast } = useToast();
  const [running, setRunning] = useState(false);

  async function handleClick() {
    setRunning(true);
    try {
      const result = await runModelCurrencyCheck();
      toast({ title: "Check finished", description: describeCheckResult(result) });
      await onDone();
    } catch (err) {
      toast({ title: "Check failed", description: describeApiError(err), variant: "destructive" });
    } finally {
      setRunning(false);
    }
  }

  return (
    <Button size="sm" onClick={handleClick} disabled={running}>
      {running ? "Checking…" : "Check now"}
    </Button>
  );
};

export default CheckNowButton;
